module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qurin1-577f2f3f9aca213f01d0a593e6c026f9.jpg";